// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cross-btn[data-v-7f160075]{width:auto;height:auto;padding:.625rem .625rem}@media(min-width:48rem){.cross-btn[data-v-7f160075]{padding:.9375rem 1.25rem}}.cancel-btn[data-v-7f160075]{grid-row:2/3;grid-column:1/3;width:100%;padding:0 .625rem .625rem .625rem;font-weight:400}@media(min-width:48rem){.cancel-btn[data-v-7f160075]{width:auto;padding:0 .625rem}}", ""]);
// Exports
module.exports = exports;
